export class CalendarEventApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCalendarEvents(params) {
    return this.#http.get('/CalendarEvent', { params });
  }

  async getCalendarEventManageable() {
    return this.#http.get('/CalendarEvent/manageable');
  }

  async createCalendarEvent({ userId, ...body }) {
    return this.#http.post('/CalendarEvent', body, { params: { userId } });
  }

  async createCalendarEventSummary(body) {
    return this.#http.post('/CalendarEvent/summary', body);
  }

  async editCalendarEvent({ calendarEventId, ...body }) {
    return this.#http.put(`/CalendarEvent/${calendarEventId}`, body);
  }

  async deleteCalendarEvent({ calendarEventId }) {
    return this.#http.delete(`/CalendarEvent/${calendarEventId}`);
  }
}
